// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".star-rating-container{display:flex;gap:4px;align-items:center}.star-icon{display:inline-flex;align-items:center;transition:transform .2s ease}.star-icon:hover{transform:scale(1.1)}", "",{"version":3,"sources":["webpack://../components/src/Components/UI/StarRating/StarRating.scss"],"names":[],"mappings":"AAAA,uBACE,YAAA,CACA,OAAA,CACA,kBAAA,CAGF,WACE,mBAAA,CACA,kBAAA,CACA,6BAAA,CAEA,iBACE,oBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
